module.exports = __webpack_public_path__ + "img/ex-nota-fiscal.33d60913.svg";